<template>
  <v-theme-provider dark>
    <base-section
      id="contact-us"
      class="youtube"
      space="36"
    >
      <v-row
        align="center"
        class="ma-0"
        justify="center"
      >
        <base-title
          align="center"
          space="0"
          title="APRENDE MÁS SOBRE SOBRE NUESTRA HERRAMIENTA"
        />

        <v-responsive
          class="px-4 mx-6"
          max-width="600"
          width="100%"
        >
          <a
            target="_blank"
            href="https://www.youtube.com/channel/UC5-fvqkC1PhMSmDYhAB3dUw"
          >
            <v-img
              max-height="72"
              contain
              :src="require('@/assets/logo-youtube-blanco.svg')"
            />
          </a>
        </v-responsive>
        <!-- <v-responsive
          class="px-4 mx-6"
          max-width="600"
          width="100%"
        >
          <base-text-field
            hide-details
            label="Your Email Address"
          >
            <template v-slot:append-outer>
              <v-btn
                class="ml-n1"
                height="40"
                outlined
                style="margin-top: -7px;"
              >
                Subscribe
              </v-btn>
            </template>
          </base-text-field>
        </v-responsive> -->
      </v-row>
    </base-section>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'SectionNewsletterAlt', // background: #ff0000ff
  }
</script>
